/**
 * Applicant modals — same shell as application module (ApplicationDetailModals).
 * Styles come from @/components/ui/modals.module.css via shared UI components.
 */
export const applicantValidationModalProps = {
  alignMessage: true,
};

/** Non–Yes/No confirms: panel header/body/footer, right-aligned modal action buttons. */
export const applicantConfirmDialogProps = {
  applicantChrome: 'default' as const,
  actionStyle: 'application' as const,
};
